// extracted by mini-css-extract-plugin
export default {"globalVersion":"TPdQhKu","globalVersionLabel":"mrMEi2t"};